import React from 'react';
const IconFormAddSquare = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M5 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.89 3 5 3ZM13 13H17V11H13V7H11V11H7V13H11V17H13V13Z" fill="#666666"/>
</svg>
);
};
export default IconFormAddSquare;